import BaseAPI from 'api/api'
/** UTIILS */


export default class ProductWarningsApi extends BaseAPI {
    static getProductWarning(props: any): Promise<any> {
        return this.api.get('product-warnings', { params: { ...props } }).then((res) => res)
    }

    static patchUpdateStatusProductWarning(id: number, props: any): Promise<any> {
        return this.api.patch(`product-warnings/${id}/status`, { ...props }).then((res) => res)
    }

    static postCreateProductWarning(payload: any) {
        return this.api.post('product-warnings', payload)
    }

    static patchUpdateProductWarning(id: number, body: any) {
        return this.api.patch(`product-warnings/${id}`, body)
    }

    static deleteProductWarning(id: number) {
        return this.api.delete(`product-warnings/${id}`)
    }

    // static findAll(props: FindAllInterface): Promise<any> {
    //     return this.api.get('product-symptoms', { params: { ...props } }).then((res) => res)
    // }
    // static create(payload: any) {
    //     return this.api.post('product-symptoms', payload)
    // }
    // static findById(id: number): Promise<ProductSymptomInterface> {
    //     return this.api.get(`product-symptoms/${id}`)
    // }
    // static update(id: number, body: ProductSymptomInterface) {
    //     return this.api.patch(`product-symptoms/${id}`, body)
    // }
    // static updateStatus(id: number, status: string): Promise<any> {
    //     return this.api.patch(`product-symptoms/${id}/status`, { id, status })
    // }
    // static remove(id: number) {
    //     return this.api.delete(`product-symptoms/${id}`)
    // }
}
